<template>
    <div class="custom-marker-wrapper">
        <img width="30px" height="30px" src="/themes/custom/ef2_custom/img/marker.svg" class="custom-marker" @click="toggle" />
    </div>
</template>
<script>
export default {
    props: {
        marker: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            open: false
        }
    },
    methods: {
        toggle() {
            this.$emit('marker-clicked', this.marker);
        },
    }
}
</script>
